import { inject } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, updateSearch } from 'bernie-core';
import { ErrorBoundary, Layer } from 'bernie-view';

import { ExitIntentModel } from 'models/common/common-types';

import { ExitIntentOverlay } from 'components/search/exit-intent-overlay';

const MOUSE_LEAVE_EVENT = 'mouseleave';
const EXIT_INTENT_ID = 'exit-intent';
const HIDE_EXIT_INTENT = 'hide-exit-intent';

export interface ExitIntentProps {
  exitIntent?: ExitIntentModel;
  analytics?: AnalyticsStore;
  showOnce?: boolean;
}

export const ExitIntent: React.FC<ExitIntentProps> = inject('analytics')(({ analytics, exitIntent, showOnce }: ExitIntentProps) => {
  const history = useHistory();
  const location = useLocation();
  const handleDismiss = () => history.goBack();

  const triggerExitIntent = () => {
    const hasOverlay = location.search.includes('pwaOverlay');
    const hasHideExitIntent = localStorage.getItem(HIDE_EXIT_INTENT);
    const hasTrackFunction = typeof analytics?.trackEvent === 'function';

    if (hasOverlay) return null;
    if (showOnce && hasHideExitIntent) return null;

    localStorage.setItem(HIDE_EXIT_INTENT, 'true');
    updateSearch({ history, location, newParams: { pwaDialog: EXIT_INTENT_ID } });

    if (hasTrackFunction) analytics.trackEvent(`.ExitIntent.Triggered`, `Exit Intent pop up was triggered`, null);

    removeMouseLeaveListener();
  };

  const removeMouseLeaveListener = () => document.body.removeEventListener(MOUSE_LEAVE_EVENT, triggerExitIntent);

  React.useEffect(() => {
    document.body.addEventListener(MOUSE_LEAVE_EVENT, triggerExitIntent);

    return removeMouseLeaveListener;
  }, []);

  return (
    <ErrorBoundary label="exit.intent.error.boundary">
      <QueryRoute query={{ pwaDialog: EXIT_INTENT_ID }}>
        <Layer id={EXIT_INTENT_ID} onDismiss={handleDismiss}>
          <ExitIntentOverlay exitIntent={exitIntent} handleDismiss={handleDismiss} />
        </Layer>
      </QueryRoute>
    </ErrorBoundary>
  );
});
